/**
 * DOM id for an AnnotationsProvider root.
 *
 * Omitting contentKey previously produced `annotations_undefined`, which
 * breaks selection scoping and can contribute to client crash loops on
 * glossary/article pages.
 *
 * @param contentKey - Optional section/block key (courses pass section._key)
 * @param contentId - Sanity/document content id (required fallback)
 * @returns Stable `annotations_*` element id
 */
export const resolveAnnotationsRootId = (
	contentKey: string | undefined,
	contentId: string,
): string => {
	return `annotations_${contentKey ?? contentId}`;
};
